import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "widget" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "bmi-value" }
const _hoisted_4 = { class: "slider" }
const _hoisted_5 = { class: "status" }
const _hoisted_6 = { class: "range" }
const _hoisted_7 = { class: "who-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "bmi-label" }, "ИМТ", -1)),
      _createElementVNode("div", {
        class: "lock-icon",
        style: _normalizeStyle({ background: _ctx.iconColor })
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "20px",
          height: "20px",
          viewBox: "0 0 24 24",
          fill: "none"
        }, [
          _createElementVNode("path", {
            d: "M12.0002 6L11.0064 9M16.5 6C17.8978 6 18.5967 6 19й.1481 6.22836C19.8831 6.53284 20.4672 7.11687 20.7716 7.85195C21 8.40326 21 9.10218 21 10.5V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V10.5C3 9.10218 3 8.40326 3.22836 7.85195C3.53284 7.11687 4.11687 6.53284 4.85195 6.22836C5.40326 6 6.10218 6 7.5 6M10 17H14M10.5415 3H13.4588C14.5397 3 15.0802 3 15.4802 3.18541C16.0136 3.43262 16.4112 3.90199 16.5674 4.46878C16.6845 4.89387 16.5957 5.42698 16.418 6.4932C16.2862 7.28376 16.2203 7.67904 16.0449 7.98778C15.8111 8.39944 15.4388 8.71481 14.9943 8.87778C14.661 9 14.2602 9 13.4588 9H10.5415C9.74006 9 9.33933 9 9.00596 8.87778C8.56146 8.71481 8.18918 8.39944 7.95536 7.98778C7.77999 7.67904 7.71411 7.28376 7.58235 6.4932C7.40465 5.42698 7.3158 4.89387 7.43291 4.46878C7.58906 3.90199 7.98669 3.43262 8.52009 3.18541C8.92014 3 9.46061 3 10.5415 3Z",
            stroke: "#fff9fae8",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)
      ]), 4)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.currentBmi), 1),
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"indicator\" data-v-e34f52d6><div class=\"indicator-segment segment-1\" data-v-e34f52d6></div><div class=\"indicator-segment segment-2\" data-v-e34f52d6></div><div class=\"indicator-segment segment-3\" data-v-e34f52d6></div><div class=\"indicator-segment segment-4\" data-v-e34f52d6></div><div class=\"indicator-segment segment-5\" data-v-e34f52d6></div><div class=\"indicator-segment segment-6\" data-v-e34f52d6></div></div>", 1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "slider-thumb",
        style: _normalizeStyle({ left: _ctx.position })
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.bmiStatus), 1),
    _createElementVNode("div", _hoisted_6, [
      _createTextVNode(_toDisplayString(_ctx.bmiRange) + " ", 1),
      _createElementVNode("span", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.currentWeight) + " кг ", 1),
        (_ctx.previousWeight)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              style: _normalizeStyle({
            color: _ctx.weightDynamics > 0 ? '#dc3545' : '#20c997',
          })
            }, _toDisplayString(_ctx.weightDynamics > 0 ? "▲" : "▼"), 5))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}